import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LockKeyhole,
  Mail,
  Eye,
  EyeOff,
  ShieldCheck,
  ArrowRight,
} from "lucide-react";

import "./AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));

    setError("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!form.email.trim()) {
      setError("Please enter your email.");
      return;
    }

    if (!form.password.trim()) {
      setError("Please enter your password.");
      return;
    }

    /*
      TEMPORARY FRONTEND LOGIN

      This will be replaced by FastAPI authentication.

      For now any valid email + password of 6+ characters
      will allow entry to the dashboard.
    */

    if (form.password.length < 6) {
      setError("Password must contain at least 6 characters.");
      return;
    }

    sessionStorage.setItem(
      "bc_admin_session",
      JSON.stringify({
        email: form.email.trim(),
        loggedIn: true,
      })
    );

    navigate("/admin");
  };

  return (
    <div className="bc-admin-login-page">
      <div className="bc-admin-login-shell">

        <section className="bc-admin-login-brand">
          <div className="bc-admin-login-badge">
            <ShieldCheck size={20} />
            Secure Administration
          </div>

          <h1>
            Bairagi Consultants
            <span>Admin Portal</span>
          </h1>

          <p>
            Manage consultation enquiries, customer requirements,
            lead progress and business opportunities from one place.
          </p>

          <div className="bc-admin-login-feature-list">
            <div>
              <span>01</span>
              <p>
                <strong>Manage Leads</strong>
                Track website and BOT enquiries.
              </p>
            </div>

            <div>
              <span>02</span>
              <p>
                <strong>Follow Opportunities</strong>
                Move prospects from new lead to conversion.
              </p>
            </div>

            <div>
              <span>03</span>
              <p>
                <strong>Business Overview</strong>
                Monitor your consultation pipeline.
              </p>
            </div>
          </div>
        </section>

        <section className="bc-admin-login-card">
          <div className="bc-admin-login-icon">
            <LockKeyhole size={24} />
          </div>

          <div className="bc-admin-login-heading">
            <h2>Welcome Back</h2>
            <p>Sign in to access the administration dashboard.</p>
          </div>

          <form onSubmit={handleSubmit}>
            <label>
              Email Address
              <div className="bc-admin-input-wrapper">
                <Mail size={18} />

                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="admin@bairagiconsultants.com"
                  autoComplete="email"
                />
              </div>
            </label>

            <label>
              Password
              <div className="bc-admin-input-wrapper">
                <LockKeyhole size={18} />

                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="bc-admin-password-toggle"
                  onClick={() =>
                    setShowPassword((previous) => !previous)
                  }
                  aria-label={
                    showPassword ? "Hide password" : "Show password"
                  }
                >
                  {showPassword ? (
                    <EyeOff size={17} />
                  ) : (
                    <Eye size={17} />
                  )}
                </button>
              </div>
            </label>

            {error && (
              <div className="bc-admin-login-error">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="bc-admin-login-button"
            >
              Sign In
              <ArrowRight size={18} />
            </button>
          </form>

          <p className="bc-admin-login-note">
            Authorized Bairagi Consultants personnel only.
          </p>
        </section>

      </div>
    </div>
  );
}

export default AdminLogin;